<template>
  <div id="app">
    <Nav/>
    <v-content>
      <router-view></router-view>
    </v-content>
    <Foot/>
  </div>
</template>

<script>
import Nav from './components/Nav'
import Foot from './components/Footer'

export default {
  name: 'App',
  components: {
    Nav,
    Foot
  }
}
</script>

<style>
@import './css/bootstrap.css';
@import './css/style.css';
@import './css/responsive.css';
@import './css/animate.css';
/*@import './css/font-awesome.min.css';*/
@import 'https://fonts.googleapis.com/css?family=Poppins:400,500,600,700,800&display=swap';
/*@import './css/slick.css';
@import './css/slick-theme.css';*/
</style>
